import React from 'react';
import { CheckCircle2, Truck } from 'lucide-react';
export function EBTWICBanner() {
  return <div className="bg-gradient-to-r from-[#047857] to-[#059669] text-white py-2 md:py-3 overflow-hidden" data-id="element-34">
      {/* Mobile marquee */}
      <div className="md:hidden" data-id="element-35">
        <div className="animate-marquee whitespace-nowrap flex items-center gap-6" data-id="element-36">
          <div className="flex items-center gap-1.5 bg-white/10 px-2.5 py-1 rounded-full" data-id="element-37">
            <CheckCircle2 className="w-3.5 h-3.5 text-[#86efac] flex-shrink-0" data-id="element-38" />
            <span className="text-xs font-bold" data-id="element-39">EBT/SNAP Accepted</span>
          </div>
          <div className="flex items-center gap-1.5 bg-[#86efac] text-[#047857] px-2.5 py-1 rounded-full" data-id="element-40">
            <CheckCircle2 className="w-3.5 h-3.5 flex-shrink-0" data-id="element-41" />
            <span className="text-xs font-bold" data-id="element-42">Free Delivery $35+</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-43">
            <Truck className="w-3.5 h-3.5 text-[#86efac] flex-shrink-0" data-id="element-44" />
            <span className="text-xs font-semibold" data-id="element-45">
              Uber Eats • DoorDash • Instacart • GrubHub
            </span>
          </div>
          {/* Duplicate for seamless loop */}
          <div className="flex items-center gap-1.5 bg-white/10 px-2.5 py-1 rounded-full" data-id="element-46">
            <CheckCircle2 className="w-3.5 h-3.5 text-[#86efac] flex-shrink-0" data-id="element-47" />
            <span className="text-xs font-bold" data-id="element-48">EBT/SNAP Accepted</span>
          </div>
          <div className="flex items-center gap-1.5 bg-[#86efac] text-[#047857] px-2.5 py-1 rounded-full" data-id="element-49">
            <CheckCircle2 className="w-3.5 h-3.5 flex-shrink-0" data-id="element-50" />
            <span className="text-xs font-bold" data-id="element-51">Free Delivery $35+</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-52">
            <Truck className="w-3.5 h-3.5 text-[#86efac] flex-shrink-0" data-id="element-53" />
            <span className="text-xs font-semibold" data-id="element-54">
              Uber Eats • DoorDash • Instacart • GrubHub
            </span>
          </div>
        </div>
      </div>

      {/* Desktop static */}
      <div className="hidden md:block max-w-7xl mx-auto px-6" data-id="element-55">
        <div className="flex items-center justify-center gap-6 lg:gap-8 flex-wrap" data-id="element-56">
          <div className="flex items-center gap-2" data-id="element-57">
            <CheckCircle2 className="w-5 h-5 text-[#86efac]" data-id="element-58" />
            <span className="text-sm font-semibold" data-id="element-59">WIC Approved</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-60">
            <CheckCircle2 className="w-5 h-5 text-[#86efac]" data-id="element-61" />
            <span className="text-sm font-semibold" data-id="element-62">EBT/SNAP</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-63">
            <CheckCircle2 className="w-5 h-5 text-[#86efac]" data-id="element-64" />
            <span className="text-sm font-semibold" data-id="element-65">USDA Partner</span>
          </div>
          <div className="flex items-center gap-2 bg-[#86efac] text-[#047857] px-3 py-1.5 rounded-full" data-id="element-66">
            <CheckCircle2 className="w-5 h-5" data-id="element-67" />
            <span className="text-sm font-bold" data-id="element-68">Free Delivery Over $35</span>
          </div>
          <div className="h-4 w-px bg-white/20" data-id="element-69" />
          <div className="flex items-center gap-3" data-id="element-70">
            <Truck className="w-5 h-5 text-[#86efac]" data-id="element-71" />
            <span className="text-sm font-semibold" data-id="element-72">Available on:</span>
            <div className="flex items-center gap-2 text-xs font-medium" data-id="element-73">
              <span className="bg-white/10 px-2 py-1 rounded" data-id="element-74">Uber Eats</span>
              <span className="bg-white/10 px-2 py-1 rounded" data-id="element-75">DoorDash</span>
              <span className="bg-white/10 px-2 py-1 rounded" data-id="element-76">Instacart</span>
              <span className="bg-white/10 px-2 py-1 rounded" data-id="element-77">GrubHub</span>
            </div>
          </div>
        </div>
      </div>
    </div>;
}